import { useConfirmStore } from 'src/stores/confirm.js'
import { useMergedConfigStore } from 'src/stores/merged_config.js'

// Ask the user to confirm: true when they accept. The question is
// { title, text, confirmText, cancelText, danger }, texts already
// translated.
export const confirm = (question) => useConfirmStore().ask(question)

// the same, only when a setting says to ask: else yes at once
export const confirmIf = async (shouldAsk, question) =>
  shouldAsk ? confirm(question) : true

// logging out, if the user wants to be asked (modalOnLogout)
export const confirmLogout = (t) =>
  confirmIf(useMergedConfigStore().mergedConfig.modalOnLogout, {
    title: t('login.logout_confirm_title'),
    text: t('login.logout_confirm'),
    confirmText: t('login.logout_confirm_accept_button'),
    cancelText: t('login.logout_confirm_cancel_button'),
    danger: true,
  })

// a question about one user, with their handle in the text
const userQuestion = (t, prefix, user, danger = true) => ({
  title: t(`user_card.${prefix}_confirm_title`),
  text: t(`user_card.${prefix}_confirm`, { user: user.screen_name_ui }),
  confirmText: t(`user_card.${prefix}_confirm_accept_button`),
  cancelText: t(`user_card.${prefix}_confirm_cancel_button`),
  danger,
})

export const confirmRemoveFollower = (t, user) =>
  confirmIf(
    useMergedConfigStore().mergedConfig.modalOnRemoveUserFromFollowers,
    userQuestion(t, 'remove_follower', user),
  )

export const confirmBlock = (t, user) =>
  confirmIf(
    useMergedConfigStore().mergedConfig.modalOnBlock,
    userQuestion(t, 'block', user),
  )

export const confirmUnfollow = (t, user) =>
  confirmIf(
    useMergedConfigStore().mergedConfig.modalOnUnfollow,
    userQuestion(t, 'unfollow', user, false),
  )
